export const DATA_BROWSING_ENTITY_DETAIL_ROUTES = {
    AssessmentLineItem: 'assessment_line_items',
    AssessmentResult: 'assessment_results',
    Calendar: 'calendars',
    Category: 'categories',
    Contact: 'contacts',
    Course: 'courses',
    District: 'districts',
    Group: 'groups',
    LineItem: 'line_items',
    Resource: 'resources',
    Result: 'results',
    Roster: 'rosters',
    SchoolAdmin: 'school_admins',
    School: 'schools',
    ScoreScale: 'score_scales',
    Staff: 'staffs',
    Student: 'students'
};

export const ENTITY_DETAIL_ROUTES = {
    assessmentLineItem: DATA_BROWSING_ENTITY_DETAIL_ROUTES['AssessmentLineItem'],
    assessmentResult: DATA_BROWSING_ENTITY_DETAIL_ROUTES['AssessmentResult'],
    calendar: DATA_BROWSING_ENTITY_DETAIL_ROUTES['Calendar'],
    category: DATA_BROWSING_ENTITY_DETAIL_ROUTES['Category'],
    contact: DATA_BROWSING_ENTITY_DETAIL_ROUTES['Contact'],
    course: DATA_BROWSING_ENTITY_DETAIL_ROUTES['Course'],
    district: DATA_BROWSING_ENTITY_DETAIL_ROUTES['District'],
    group: DATA_BROWSING_ENTITY_DETAIL_ROUTES['Group'],
    lineItem: DATA_BROWSING_ENTITY_DETAIL_ROUTES['LineItem'],
    resource: DATA_BROWSING_ENTITY_DETAIL_ROUTES['Resource'],
    result: DATA_BROWSING_ENTITY_DETAIL_ROUTES['Result'],
    roster: DATA_BROWSING_ENTITY_DETAIL_ROUTES['Roster'],
    schooladmin: DATA_BROWSING_ENTITY_DETAIL_ROUTES['SchoolAdmin'],
    school: DATA_BROWSING_ENTITY_DETAIL_ROUTES['School'],
    scoreScale: DATA_BROWSING_ENTITY_DETAIL_ROUTES['ScoreScale'],
    staff: DATA_BROWSING_ENTITY_DETAIL_ROUTES['Staff'],
    student: DATA_BROWSING_ENTITY_DETAIL_ROUTES['Student'],
};
Object.keys(DATA_BROWSING_ENTITY_DETAIL_ROUTES).forEach((type: string) => {
    ENTITY_DETAIL_ROUTES[type] = DATA_BROWSING_ENTITY_DETAIL_ROUTES[type];
    ENTITY_DETAIL_ROUTES[type.toLowerCase()] = DATA_BROWSING_ENTITY_DETAIL_ROUTES[type];
});

export enum DATA_BROWSING_ENTITY_TYPES {
    'rostering' = 'rostering',
    'gradebook' = 'gradebook',
    'resource' = 'resource'
}
